import {
    createFirebaseApp,
    createAuth,
    createFirestore,
    createFunctions,
    createStorage,
} from '@repo/firebase';
import { DATABASES } from '@repo/config/appIdentifiers.js';

const firebase = createFirebaseApp();
// Impersonation tabs (admin-app handoff) need session-only persistence so the
// impersonated session doesn't leak into the user's persistent TAP session.
const auth = createAuth(firebase, { enableImpersonation: true });

// TAP's primary DB: holds the TAP user doc (redeemedCodes, joinedAt, etc.)
// and per-user data (annotations, archived-annotations).
const db = createFirestore(firebase, { databaseId: DATABASES.TAP });

// Content DB: shared content source of truth — courses, collections,
// resources, roles, actions, content-actions, etc. Admin authors here;
// TAP and Education both read from it.
const contentDb = createFirestore(firebase, { databaseId: DATABASES.CONTENT });

const { functions, callable, functionsCustomDomain } = createFunctions(firebase, {
    customDomain: import.meta.env.VITE_CLOUD_FUNCTION_URL || undefined,
});
const storage = createStorage(firebase);

export { firebase, auth, db, contentDb, functions, callable, functionsCustomDomain, storage };
